import { render } from "./BookingForms.vue?vue&type=template&id=475c0c5c&scoped=true"
import script from "./BookingForms.vue?vue&type=script&lang=js"
export * from "./BookingForms.vue?vue&type=script&lang=js"

import "./BookingForms.vue?vue&type=style&index=0&id=475c0c5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475c0c5c"]])

export default __exports__